import { render, staticRenderFns } from "./ExpenseDetail.vue?vue&type=template&id=3c5770c6&"
import script from "./ExpenseDetail.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports